import { createFileRoute } from '@tanstack/react-router'
import { SetNewPasswordForm } from '@/features/set-new-password-form/ui/SetNewPasswordForm'

export const Route = createFileRoute('/_login/login/forgot-password/set-new-password')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SetNewPasswordForm />
}
